'use client';
import useDeviceDetect from '@/hooks/deviceDetect';
import useHeaderStore from '@/store/header';
import React, { useEffect } from 'react';
const Overlay = ({ children, backdropClass = '' }: { backdropClass?: string; children: React.ReactNode }) => {
  const overlay = useHeaderStore((state) => state.overlay);
  const activateOverlay = useHeaderStore((state) => state.activateOverlay);
  const navPanel = useHeaderStore((state) => state.navPanel);
  const { isMobile } = useDeviceDetect();

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (overlay) {
        document.body.classList.add('overflow-y-hidden');
        document.body.classList.remove('overflow-y-auto');
      } else {
        document.body.classList.add('overflow-y-auto');
        document.body.classList.remove('overflow-y-hidden');
      }
    }
  }, [overlay]);

  return (
    <>
      <div className={`overlay pointer-events-none fixed bottom-0 left-0 right-0 top-0 ${navPanel ? 'z-40' : 'z-[9999]'} `}>
        <div
          className={`absolute bottom-0 left-0 right-0 top-0 bg-black transition-opacity ${backdropClass} ${
            overlay ? 'pointer-events-auto opacity-40' : 'opacity-0'
          } ${isMobile ? 'top-[calc(var(--header-height)_+_var(--announcement-bar-height,0px))]' : ''}`} // Strict check for true, undefined/null (SSR) gets empty string
          onClick={() => activateOverlay(false)}
        />
        <div className={`overlay-content-wrapper relative z-[99999] h-full`}>{children}</div>
      </div>
      <style jsx>{`
        .overlay-content-wrapper :global(*:not(svg path)) {
          pointer-events: auto;
        }

        // @media (max-width: 1024px) {
        .backdrop {
          top: calc(var(--preheader-height) + var(--header-height));
          backdrop-filter: none;
        }
        // }
      `}</style>
    </>
  );
};

export default Overlay;
